<div class="main">

  <div class="progress-bar-container">
    <mat-progress-bar mode="determinate" value={{progressBarValue}} class="custom-progress-bar"></mat-progress-bar>
    <!-- <p>{{progressBarValue + '%'}}</p> -->
  </div>
    <div class="page-container">
    <a href="/saude-resumo" class="health-card">
      <div class="content">
        <h2>Resumo da sua saúde</h2>
        <p>Clique e acompanhe o seu progresso.</p>
      </div>
      <div class="avatar-area">
        <img src="../../../assets/images/cindi de lado.svg" alt="avatar">
      </div>
    </a>
  </div>
  
  <div class="chat" id="chat">
    <div class="cindi-img-container">
      <img alt="cindi" src="../../../assets/images/cindi.svg">
    </div>
  </div>

</div>
<app-loading-screen></app-loading-screen>